import React, { useEffect, useState, appState } from "react";
import { Icon } from "@fluentui/react/lib/Icon";
import Chrsalis_logo from "../../assets/Chrsalis_logo.svg";
import { useAxios } from "../../context/AxiosContext";
import { useAppInsights } from "../../context/TelemetryContext";



function Others({
  data,
  resultData,
  // enableSearchSuggestion,
  // searchSuggestionId,
  // setSearchSuggestionId,
  currentPage,
}) {
  const { axiosGetService } = useAxios();
  const { track } = useAppInsights();
  const [showText, setShowText] = useState(false);
  
  const handleNavigation = (e, url) => {
    // e.preventDefault();
    track(1, 400, data.id, data.title, { pageNumber: currentPage });

    // Open the URL in a new tab with the appropriate prefix if missing
    let formattedUrl =
      url.startsWith("http://") || url.startsWith("https://")
        ? url
        : `http://${url}`;
    window.open(formattedUrl, "_blank", "noopener,noreferrer");
  };

  // addign Transaction type to findit data
  let transactionType = resultData.finditTransactionId;
  const findItData = {
    findItId: data.id,
    transactionType,

  };

  return (
    <div
      tabIndex={0}
      className="tabsWrapper phaseTabsSearch"
      id={`search_phase_${data.id}`}
    >
      <div className="tabsImageWrapper">
        <div className="imageOfTemplateDiv">
          <img
            src={Chrsalis_logo}
            className="imageOfSearchResult"
            alt="fileType"
          />
        </div>
      </div>
      <div className="tabsDescriptionWrapper">
        <div
        >
          <a
          style={{paddingTop:8,color:'#0070c0' ,fontSize:14,fontWeight: 600,position:'relative'}}
          className="tabTitle findIt-search-result-link"
          finditdata={JSON.stringify(findItData)}
            href={data.fileLocationNew}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => handleNavigation(e, data.fileLocationNew)}
            key={data.title}
          >
            {data.title}
          </a>
        </div>
        {showText ? (
          <div className="descriptionOfTabs">
            <p>
              {data.description === null || data.description.length === 0 ? (
                <span>To be Updated</span>
              ) : data.description.length > 800 ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: `${data.description.slice(0, 800)}...`,
                  }}
                />
              ) : (
                <span dangerouslySetInnerHTML={{ __html: data.description }} />
              )}
            </p>
          </div>
        ) : null}
        <div className="detailsOfTabs">
          <div className="otherDetailsOfTab">
            <div className="phaseDetails">
              <span className="phaseLabel">Chrysalis : {data.artifact} - </span>
              <span class="phaseName">{data.artifactType ?? "NA"}</span>
              <div
                className="tabExpandedViewIcon"
                onClick={() => setShowText(!showText)}
                tabIndex={0}
                onKeyPress={(e) => {
                  if (e.which === 13) {
                    setShowText(!showText);
                  }
                }}
                title="Expand Phase"
                aria-expanded={showText}
                role="button"
                aria-label={
                  showText
                    ? "Click to Collapse Phase information"
                    : "Click to expand Phase information"
                }
              >
                {showText ? (
                  <Icon iconName="ChevronUpMed" />
                ) : (
                  <Icon iconName="ChevronDownMed" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Others;
